import { styled } from '../../../theme/stitches.config';

export const SMPKnockoutHeaderContainer = styled.withConfig({ componentId: 'CommonWidget', displayName: 'KnockoutHeaderContainer' })(
  'div',
  {
    boxSizing: 'border-box',
    bc: '$knockoutHeaderBgColor',
    border: '1px solid $knockoutHeaderBorderColor',
    borderRadius: '$2',
    height: '48px',
    top: 0,
    zIndex: '2',
  },
);
